import script from "./CreateLocationModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateLocationModal.vue?vue&type=script&lang=ts&setup=true"

import "./CreateLocationModal.vue?vue&type=style&index=0&id=16d86527&lang=scss"

const __exports__ = script;

export default __exports__